export default {
    header: "ประวัติการรับสิทธิ์",
    redeemedOn: "วันที่ : ",
    useNow: "กดใช้สิทธิ์",
    expired: "หมดอายุ",
    used: "ใช้แล้ว",
    use: "ใช้",
    
    mark_used: "กดใช้สิทธิ์ (สำหรับพนักงาน)",
    confirm: {
        title: "ยืนยันการใช้สิทธิ์",
        cancel: "ยกเลิก",
        confirm: "ยืนยัน",
    },
}
